import {
	Directive, ElementRef,
	EventEmitter,
	HostBinding, HostListener,
	Input, OnDestroy, OnInit,
	Output,
	TemplateRef,
	ViewContainerRef
} from '@angular/core';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[cdkDetailRow]'
})
export class CdkDetailRowDirective implements OnInit, OnDestroy {

  // Properties
  public row: any;
  public opened: boolean;
  private tRef: TemplateRef<any>;
  private expandSubscription: Subscription;
  @Input() expandListener: EventEmitter<boolean>;

	// Static Methods
	static getTableHeight(tableContainerRef: ElementRef): number {
		// PRE: a reference to the table's container
		// POST: returns the amount of space the table may take up
		// NOTE: this won't work if you have multiple dynamic elements one after the other; you'll need to adjust it
		const tableHeightString = window.getComputedStyle(tableContainerRef.nativeElement.offsetParent, null).getPropertyValue('padding-bottom');
        let tableHeight = -(Number.parseInt(tableHeightString.replace('px', '')));
		tableHeight -= tableContainerRef.nativeElement.offsetTop;
		if (tableContainerRef) {
			if (tableContainerRef.nativeElement.nextElementSibling) {
				tableHeight += tableContainerRef.nativeElement.nextElementSibling.offsetTop;
			} else {
                if (tableContainerRef.nativeElement.offsetParent.clientHeight < tableContainerRef.nativeElement.offsetParent.offsetHeight) {
                    tableHeight += tableContainerRef.nativeElement.offsetParent.clientHeight;
                } else {
                    tableHeight += tableContainerRef.nativeElement.offsetParent.offsetHeight;
                }
			}
		}
		return tableHeight;
	}

	static getTableWidth(tableContainerRef: ElementRef): number {
		// PRE: a reference to the table's container
		// POST: returns how much width the table may take up
		if (tableContainerRef) {
			return tableContainerRef.nativeElement.scrollWidth;
		}
	}

  // Event Functions
  @HostBinding('class.expanded')
  get expended(): boolean {
	// console.log('hostbindng');
	return this.opened;
  }

  @Input()
  set cdkDetailRow(value: any) {
	// console.log('cdbDetailRow');
	if (value !== this.row) {
	  this.row = value;
	  // this.render();
	}
  }

  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
	// console.log('cdkDetailRowTpl');
	if (value !== this.tRef) {
	  this.tRef = value;
	}
  }

  @HostListener('click')
  onClick(): void {
  	// console.log('hostListener');
	this.toggle();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
		if (event.key == 'Enter' || event.key == ' ') {
			this.toggle();
		}
  }

  @Output() toggleChange = new EventEmitter<CdkDetailRowDirective>();

  ngOnInit() {
  	// POST: subscribes to expansion
  	if (this.expandListener != null) {
  		this.expandSubscription = this.expandListener.subscribe(expand => {
  			if (expand && !this.opened) {
  				this.toggle();
			} else if (!expand && this.opened) {
  				this.toggle();
			}
		});
	}
  }

  ngOnDestroy() {
  	// POST: ends the subscription to expansion
	  if (this.expandSubscription != null) {
		  this.expandSubscription.unsubscribe();
	  }
  }

  // Class Functions
  constructor(
	public vcRef: ViewContainerRef
  ) { }

  // Methods
  toggle(): void {
	// console.log('toggle');
	if (this.opened) {
	  this.vcRef.clear();
	} else {
	  this.render();
	}
	this.opened = this.vcRef.length > 0;
	this.toggleChange.emit(this);
  }

  private render(): void {
	// console.log('render');
	this.vcRef.clear();
	if (this.tRef && this.row) {
	  this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
	}
  }
}
